<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div>
          <div class="label-input">Section Background</div>
          <div class="mb-5 group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.backgroundColor"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields.backgroundColor" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields.textColor" label="Text Color" />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="label-input">Primary Content</div>
        <div class="group-item mb-5">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showLeftGroup" style="margin-bottom: 0" class="font-weight-bold">Show</label>
            <input type="checkbox" v-model="fields.showLeftGroup" id="showLeftGroup" />
          </div>
          <v-divider class="my-5"></v-divider>
          <v-select
            :value="fields.order.leftGroup"
            :items="orderOptions"
            @change="handleChangeOrderLeftGroup"
            label="Primary Group Order"
          />
          <div>
            <div class="font-weight-bold mb-2">Icon</div>
            <div class="group-item mb-5">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label for="showIcon" style="margin-bottom: 0" class="">Show</label>
                <input type="checkbox" v-model="fields.icon.show" id="showIcon" />
              </div>
              <UploadImage
                @callback="obj => handleUploadIcon(obj)"
                :image="{ imageSrc: fields.icon.src }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveIcon"
              />
            </div>
          </div>

          <div>
            <div class="font-weight-bold mb-2">Text Content Primary</div>
            <div class="group-item mb-5">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label for="showTextPrimary" style="margin-bottom: 0" class="">Show</label>
                <input type="checkbox" v-model="fields.textContentPrimary.show" id="showTextPrimary" />
              </div>
              <ckeditor :editor="editor" v-model="fields.textContentPrimary.text" :config="editorConfig" />
            </div>
          </div>
        </div>

        <div class="label-input mt-10">Secondary Content</div>
        <div class="group-item">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showRightGroup" style="margin-bottom: 0" class="font-weight-bold">Show</label>
            <input type="checkbox" v-model="fields.showRightGroup" id="showRightGroup" />
          </div>
          <v-divider class="my-5"></v-divider>
          <!-- <div class="label-input">Order</div> -->
          <v-select
            :value="fields.order.rightGroup"
            :items="orderOptions"
            @change="handleChangeOrderRightGroup"
            label="Secondary Group Order"
          />
          <div>
            <div class="font-weight-bold">Text Content Secondary</div>
            <div class="group-item mb-5">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label for="showTextSecondary" style="margin-bottom: 0" class="">Show</label>
                <input type="checkbox" v-model="fields.textContentSecondary.show" id="showTextSecondary" />
              </div>
              <ckeditor :editor="editor" v-model="fields.textContentSecondary.text" :config="editorConfig" />
            </div>
          </div>

          <div>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showButton" style="margin-bottom: 0" class="font-weight-bold">Button</label>
              <input type="checkbox" v-model="fields.button.show" id="showButton" />
            </div>
            <div class="group-item mb-5" v-if="fields.button.show">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="fields.button.text" label="Button Text" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="fields.button.link" label="Button Link" />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="button-background-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields.button.backgroundColor"
                      @change="handleChangeButtonBackground"
                    />
                    <v-text-field v-model="fields.button.backgroundColor" label="Background Color" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="button-text-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields.button.color"
                      @change="handleChangeButtonTextColor"
                    />
                    <v-text-field v-model="fields.button.color" label="Text Color" />
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="fields.button.subBtn" label="Sub Button Text" />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'CardBasicB1',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      orderOptions: [
        { text: 'Left', value: 1 },
        { text: 'Right', value: 2 },
      ],
      fields: {
        title: 'Card Basic B1 Section',
        backgroundColor: '#281707',
        textColor: '#000000',
        showLeftGroup: true,
        showRightGroup: true,
        order: {
          leftGroup: 1,
          rightGroup: 2,
        },
        textContentPrimary: {
          show: true,
          text: '',
        },
        icon: {
          show: true,
          src: '',
        },
        textContentSecondary: {
          show: true,
          text: '',
        },
        padding: {
          top: true,
          bottom: true,
        },
        button: {
          text: 'LIGHTEN UP YOUR SPACE NOW',
          backgroundColor: '#aa6d32',
          color: '#ffffff',
          show: true,
          link: '#',
          subBtn: 'Get faster shipping when you buy 2+',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardBasicB1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeBackgroundColor(event) {
      this.fields.backgroundColor = event.target.value;
    },
    handleChangeButtonBackground(event) {
      this.fields.button.backgroundColor = event.target.value;
    },
    handleChangeButtonTextColor(event) {
      this.fields.button.color = event.target.value;
    },
    handleUploadIcon(obj) {
      this.fields.icon.src = obj.imageSrc;
    },
    handleRemoveIcon() {
      this.fields.icon.src = '';
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleChangeOrderRightGroup(value) {
      this.fields.order.rightGroup = value;
      this.fields.order.leftGroup = value === 1 ? 2 : 1;
    },
    handleChangeOrderLeftGroup(value) {
      this.fields.order.leftGroup = value;
      this.fields.order.rightGroup = value === 1 ? 2 : 1;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
